<template>
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-img :src="sideImg" max-height="80vh" contain></v-img>
        </v-col>
        <v-col cols="6">
          <v-row justify="center">
            <v-col cols="12">
              <div class="text-center text-h4">{{welcomeText}}</div>
              <div class="text-center text-subtitle-2">{{descText}}</div>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn @click="roll">Roll!</v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-container
              id="scroll-target"
              style="max-height: 50vh"
              class="overflow-y-auto mt-3"
            >
              <v-row justify="center">
                <SimpleRouletteCard
                v-for="card in cards"
                v-bind:rollTitle = "card.rollTitle"
                v-bind:cumulative = "card.cumulative"
                v-bind:items = "card.items"
                v-bind:rolled= "card.rolled"
                ></SimpleRouletteCard>
              </v-row>
            </v-container>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </template>

  <script>
      import SimpleRouletteCard from './SimpleRouletteCard';
  
      export default {
        name: 'SimpleRoulette',
        props: {
          welcomeText: String,
          descText: String,
          sideImg: String,
          cards: Array,
        },
        components: {
          SimpleRouletteCard,
        },
        data: () => ({

        }),
        methods: {
          roll() {
            this.cards.forEach(function(card) {
              card.rolled = true;
            })
          }
        },
      }
  </script>